import PeopleRouteType from '../store/schema/PeopleRouteType';
import { action } from 'satcheljs';
import {
    SettingsSubRoutes,
    SettingsCategoryOption,
} from 'mini-options-view/lib/schema/SettingsSubRoutes';

export default action(
    'setCurrentPeopleRoute',
    (
        location: PeopleRouteType,
        folderId: string = null,
        subRoute: SettingsSubRoutes = null,
        subRouteOption: SettingsCategoryOption = null
    ) => ({
        location,
        folderId,
        subRoute,
        subRouteOption,
    })
);
